// extracted by mini-css-extract-plugin
export default {"logo":"ClickableCard_logo__Pgjr0","Card":"ClickableCard_Card__JKotm","translateY":"ClickableCard_translateY__pyyJR"};